import { LaneType } from 'common-types';

export enum JobsTypeEnum {
  MIXPANEL = 'Mixpanel',
}

export type JobType = {
  _id: LaneType.UUID;
  _created: Date;
  _updated: Date;
  type: JobsTypeEnum | string;
  data: { lastMixpanelUpdate: Date };
};
